import React from 'react';

function Education() {
    return(
        <div class="container pt-5 my-5" id="Education">
            {/* <a href="#Education"></a> */}
            <div class="row">
                <div class="col">
                    <span class="border border-dark">
                        <img src="https://images.unsplash.com/photo-1601807576163-587225545555?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1546&q=80" alt="library" width="100%"/>
                    </span>
                </div>
                <div class="col">
                    <h1>
                        <br/>Education
                    </h1>
                    <h3>Formal</h3>
                    <p>
                        &emsp;BS, Information Technology,<br/>
                        &emsp;Columbus State University, Columbus, GA<br/>
                        &emsp;Planned Graduation 2023<br/>
                    </p>
                    <h3>Certifications</h3>
                    <p>
                        &emsp;Web Development Certificate<br/>
                        &emsp;Columbus State University, Columbus, GA
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Education